import React from 'react';
import PropTypes from 'prop-types';
import styles from './MenuClubList.module.css';

const MenuClubList = ({ selectedClub, clubs }) => {
  return (
    <div className={styles.sidebarClubInfo}>
      <div className={styles.sidebarClubBadge}>
        {selectedClub?.image ? (
          <img
            src={selectedClub.image}
            alt="club"
            className={styles.clubImage}
          />
        ) : (
          <span className={styles.clubInitials}>
            {selectedClub?.clubName
              ?.split(' ')
              .map((w) => w[0])
              .join('')
              .substring(0, 2)}
          </span>
        )}
      </div>
      <div className={styles.sidebarClubDetails}>
        <h3>{selectedClub?.clubName}</h3>
        <p>{selectedClub?.userRole}</p>
      </div>
    </div>
  );
};

MenuClubList.propTypes = {
  selectedClub: PropTypes.object,
  clubs: PropTypes.array,
};

export default MenuClubList;
